module.exports = __webpack_public_path__ + "img/6.82482d6b.jpg";